export default function Footer() {
  return (
    <footer className="relative mt-12 pt-8 text-center text-sm text-gray-500">
      {/* R/W/B gradient bar */}
      <div
        aria-hidden
        className="absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r from-red-600 via-white to-blue-600"
      />

      <p>© {new Date().getFullYear()} Operations Holdings. All rights reserved.</p>

      {/* <p className="mt-1">
        <a href="/companies" className="hover:underline hover:text-gray-700 transition">
          Our Companies
        </a>
      </p> */}

      <p className="mt-3 text-xs text-gray-450">
        Designed by{" "}
        <a
          href="https://johnnyfaris.com"
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-gray-450 hover:text-gray-700 hover:underline"
          aria-label="Designed by Champion Lifestyle — Johnny Faris portfolio"
        >
          Champion Lifestyle
        </a>
      </p>
    </footer>
  );
}
